import { AuxProgressIndicator, AuxGrid } from "@blk/aladdin-react-components-es";
import { AuxProgressIndicatorTypeEnum, AuxGridColumnType } from "@blk/aladdin-web-components";
import React from "react";
import { InsDownloadDetailsButton } from "components/campaigns/insDownloadDetailsButton";
import { useGetCampaignSubmissionsQuery } from "components/campaigns/store/api";
import { dateFormatter } from "components/campaigns/store/common";
import { CustomColumnType } from "components/widgets/grid/grid-column-types";
import { language } from "language/default";
const columnDefinitions = [
    {
        cellRenderer: (params) => {
            if (params.data) {
                const { id, status, campaignId } = params.data;
                return React.createElement(InsDownloadDetailsButton, { campaignId: campaignId, disabled: status === "Pending" || status === "Cancelled" || status === "Declined", id: id });
            }
            return React.createElement(React.Fragment, null);
        },
        headerName: language.en.campaigns.submissionsGrid.download,
        type: [CustomColumnType.InsCenterAllignedColumn],
        width: 80
    },
    { field: "referenceDate", headerName: language.en.campaigns.asOfDate, sort: "desc", sortIndex: 0, type: CustomColumnType.InsDateColumn, valueFormatter: dateFormatter },
    { field: "campaign", headerName: language.en.campaigns.submissionsGrid.campaign, sort: "asc", sortIndex: 1, type: AuxGridColumnType.AUX_TEXT_COLUMN },
    { field: "fundManager", headerName: language.en.campaigns.submissionsGrid.fundManager, type: AuxGridColumnType.AUX_TEXT_COLUMN },
    { field: "fundName", headerName: language.en.campaigns.submissionsGrid.fundName, type: AuxGridColumnType.AUX_TEXT_COLUMN },
    { field: "assetClass", headerName: language.en.campaigns.submissionsGrid.assetClass, type: CustomColumnType.InsTextSetColumn },
    { field: "compliance", headerName: language.en.campaigns.submissionsGrid.compliance, type: AuxGridColumnType.AUX_TEXT_COLUMN },
    { field: "status", headerName: language.en.campaigns.submissionsGrid.status, type: CustomColumnType.InsTextSetColumn },
    { field: "transformStatus", headerName: language.en.campaigns.submissionsGrid.transformStatus, type: AuxGridColumnType.AUX_TEXT_COLUMN },
    { field: "validateStatus", headerName: language.en.campaigns.submissionsGrid.validateStatus, type: AuxGridColumnType.AUX_TEXT_COLUMN },
    { field: "reportReceivedOn", headerName: language.en.campaigns.submissionsGrid.reportReceivedOn, type: CustomColumnType.InsDateColumn, valueFormatter: dateFormatter },
    { field: "lastDataAvailableInInsight",
        headerName: language.en.campaigns.submissionsGrid.lastDataAvailableInInsight,
        type: CustomColumnType.InsDateColumn,
        valueFormatter: dateFormatter },
    { field: "firstDataAvailableInInsight",
        headerName: language.en.campaigns.submissionsGrid.firstDataAvailableInInsight,
        type: CustomColumnType.InsDateColumn,
        valueFormatter: dateFormatter },
    { field: "availableInInsight",
        headerName: language.en.campaigns.submissionsGrid.availableInInsight,
        type: CustomColumnType.InsDateColumn,
        valueFormatter: dateFormatter },
    { field: "completeReportReceivedOn",
        headerName: language.en.campaigns.submissionsGrid.completeReportReceivedOn,
        type: CustomColumnType.InsDateColumn,
        valueFormatter: dateFormatter },
    { field: "description", headerName: language.en.campaigns.submissionsGrid.description, type: AuxGridColumnType.AUX_TEXT_COLUMN }
];
const InsSubmissionsDatExportGrid = () => {
    const { data, isFetching } = useGetCampaignSubmissionsQuery({ campaignIds: [] });
    if (isFetching) {
        return React.createElement("div", { className: "loading-indicator" },
            React.createElement(AuxProgressIndicator, { hasLabel: false, isSpinner: true, progress: 25, type: AuxProgressIndicatorTypeEnum.LOADING }));
    }
    return React.createElement(AuxGrid, { className: "campaignContent", domLayout: "autoHeight", columnDefs: columnDefinitions, rowData: data?.filter((submission) => submission.status && ["Submitted", "Uploaded", "Validated"].indexOf(submission.status) > -1) });
};
export default InsSubmissionsDatExportGrid;
